export enum AttributionMode {
  AttributionPeriod = 'AttributionPeriod',
  ExplicitlySet = 'ExplicitlySet',
}
